export const usePathWithoutLangCountry = () => {
  const route = useRoute()
  return computed(() => {
    if (!route.fullPath) return ''

    return route.fullPath.split('/').slice(2).join('/')
  })
}
